import { useEffect, useState } from "react";
import { Repository as PilotStationApiRepository } from '@pilot-web/pilot-station';
import "./favouriteStations.css"
import Icons from "../icons/Icons";
import { IconColors } from "../../../services/SystemNames";
import ContentGrid from "../ContentGrid";
import Spacer from "../Spacer";
import MetaIdbRepository from "../../../repositories/idb/MetaIdbRepository";
import { isObjectNull } from "../../helpers/ObjectHelpers";
import { shouldUseIdb } from "../../helpers/AuthHelpers";
import { useWarningNotification } from 'components/hooks/useAppStore';

const FavouriteStations = () => {
    const [stations, setStations] = useState([]);
    const addWarningNotification = useWarningNotification();

    const fetchStationsPreferences = async () => {
        const response = await PilotStationApiRepository.getStationsPreferences();
        if (response.ok) {
            var result = await response.json();
            setStations(result);
        }
        else {
            addWarningNotification("Det oppstod en feil ved kommunikasjon med tjeneste");
        }
    }

    const fetchStations = async () => {
        const response = await PilotStationApiRepository.getStations();
        if (response.ok) {
            const result = await response.json();
            const preferences = await MetaIdbRepository.getFavouriteStationsAsync();
            const preferencesValue = preferences.value || [];

            for (const station of result) {
                const existingStation = preferencesValue.find(s => s.departmentID === station.departmentID);
                station.isFavourite = !isObjectNull(existingStation);
            }
            
            setStations(result);
        }
        else {
            addWarningNotification("Det oppstod en feil ved kommunikasjon med tjeneste");
        }
    }

    const getStations = async () => {
        if (shouldUseIdb()) {
            return fetchStations();
        } else {
            return await fetchStationsPreferences();
        }
    };

    const setStationFavourite = (station) => {
        const nextStations = stations.map((s) => {
            if (s.departmentID === station.departmentID) {
                s.isFavourite = station.isFavourite;
                return s;
            } else {
                return s;
            }
        })
        setStations(nextStations);
    }

    const setStationFavouriteApi = async (station) => {
        var response = await PilotStationApiRepository.setPreferencesFavouriteStation(station);
        if(response.ok)
        {
            setStationFavourite(station);
        }
        else
        {
            addWarningNotification("Det oppstod en feil ved kommunikasjon med tjeneste");
        }
    };

    const setStationFavouriteIdb = async (station) => {

        const obj = { departmentID: station.departmentID };
        const preferences = await MetaIdbRepository.getFavouriteStationsAsync();
        const preferencesValue = preferences.value || [];
        const existingStation = preferencesValue.find(s => s.departmentID === station.departmentID);
        
        if (station.isFavourite) {
            if (!existingStation) 
                preferencesValue.push(obj);
        } else if (existingStation) {
            const index = preferencesValue.indexOf(existingStation);
            if (index > -1) {
                preferencesValue.splice(index, 1);
            }
        }
        await MetaIdbRepository.setFavouriteStationsAsync(preferencesValue);
        setStationFavourite(station);
    }

    const toggleStationFavourite = (station) => {
        station.isFavourite = !station.isFavourite;

        if (shouldUseIdb()) {
            setStationFavouriteIdb(station);
        } else {
            setStationFavouriteApi(station)
        }
        
    };

    useEffect(() => {
        getStations();
    }, []);

    return (
        <ContentGrid title="Stasjoner" titleIcon="star">
            <div className="favourites-table">
                {stations.map((station, s) => (
                    <div key={s}
                        style={{ backgroundColor: station.isFavourite ? "var(--favourites-active-bg)" : "var(--favourites-bg)" }}
                        className="favourites-row"
                        onClick={() => { toggleStationFavourite(station) }}>
                        <div className="favourites-name font-size-xl">
                            {station.departmentName}
                        </div>
                        <div className="favourites-icon">
                            <Icons className="pointer" color={IconColors.Active} iconName={station.isFavourite ? "star" : "starOutline"} />
                        </div>
                    </div>
                ))}
            </div>
            <Spacer/>
        </ContentGrid>
    );
};

export default FavouriteStations;
